export default class Vars
{
    public static CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
    public static GRAPH_SCOPES = ['User.Read', 'User.ReadBasic.All', 'Sites.Read.All', 'offline_access'];
    public static ENTITY_ID_PREFIX = 'news-connector';
}